import { PATH_NAME_NOT_FOUND } from '@/common/router.const'

export default [
  {
    path: '*',
    name: PATH_NAME_NOT_FOUND,
    components: {
      notfound: () => import('@/views/error/NotFound')
    }
  }
]
